import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
    scrollBehavior() {
        return {x: 0, y: 0};
    },
    routes: [
        {
            path: "/",
            component: () => import("./components/layout/basic-layout.vue"),
            children: [
                {
                    path: "",
                    name: "delivery/list",
                    component: () => import("./views/table/delivery/delivery-list.vue")
                },
                {
                    path: "delivery/:id",
                    name: "delivery/detail",
                    component: () => import("./views/table/delivery/delivery-detail.vue")
                },
                {
                    path: "checkout",
                    name: "checkout",
                    component: () => import("./views/table/checkout/checkout.vue")
                },
                {
                    path: "ordered",
                    name: "ordered",
                    component: () => import("./views/table/ordered/ordered.vue")
                },
                {
                    path: "store",
                    name: "store/delivery/list",
                    component: () => import("./views/store/delivery/delivery-list.vue")
                },
                {
                    path: "store/delivery/:id",
                    name: "store/delivery/detail",
                    component: () => import("./views/store/delivery/delivery-detail.vue")
                },
                {
                    path: "store/checkout",
                    name: "store/checkout",
                    component: () => import("./views/store/checkout/checkout.vue")
                },
                {
                    path: "detail/:id",
                    name: "good/detail",
                    component: () => import("./views/detail-garnish/detail.vue")
                }
            ]
        },
        {
            path: "/home",
            name: "home",
            component: () => import("./views/store/home/home.vue")
        },
        {
            // 商家app所有桌子页
            path: "/table/list",
            name: "table",
            component: () => import("./views/store-table/list.vue")
        },
        {
            // 商家app注册成功页
            path: "/register/success",
            name: "register",
            component: () => import("./views/store-register/success.vue")
        }
    ]
});

export default router;
